import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal } from 'antd';
import { Website } from '../../types';
import WebsiteForm from '../WebsiteForm/WebsiteForm';
import {
  useActiveWebsite,
  useWebsitesStoreLoading,
  useWebsitesFacade,
} from '../../store/hooks';

type RouteParams = { id?: string };

const WebsiteFormContainer: React.FC<RouteComponentProps<RouteParams>> = ({
  history,
  match,
}) => {
  const activeWebsite = useActiveWebsite();
  const isLoading = useWebsitesStoreLoading();
  const facade = useWebsitesFacade();
  const id = match.params.id;

  useEffect(() => {
    if (id) {
      facade.setActiveWebsite(id);
    }
  }, [facade, id]);

  const redirectToList = () => {
    history.replace('/admin/websites');
    facade.setActiveWebsite(null);
  };

  const handleSubmit = (obj: Website) => {
    redirectToList();

    if (id) {
      facade.update(id, obj);
    } else {
      facade.create(obj);
    }
  };

  if (isLoading) {
    return null;
  }

  return (
    <Modal
      title={id ? 'Edit website' : 'Create website'}
      width={460}
      destroyOnClose={true}
      visible={true}
      footer={null}
      onCancel={redirectToList}
    >
      <WebsiteForm data={activeWebsite} onSubmit={handleSubmit} />
    </Modal>
  );
};

export default WebsiteFormContainer;
